import {groupRights} from "@services/current-rights.service";
import {guard} from "@/app/routes/guards/guard-factory";

export const guardExercisesEdit = guard(groupRights.Exercises)('edit')
export const guardExercisesWatch = guard(groupRights.Exercises)('watch')
export const guardExercisesCreate = guard(groupRights.Exercises)('create')

